const itemsForComparison = [];

const comparePageLink = document.querySelector('#compare-url a');
const clearSelectionLink = document.querySelector('#compare-clear a');

const renderComparisonImages = () => {
    const comparisonContainer = document.querySelector('.compare-selections');
    if (!comparisonContainer) {
        return;
    }

    const comparisonDivs = comparisonContainer.querySelectorAll('.compare-selections div[data-sku]');
    comparisonDivs.forEach((currentDiv, index) => {
        const containerId = `product${index + 1}`;
        const itemForComparison = itemsForComparison[index];

        // To avoid a re-render with a "blip", skip if there is already a selected product in this position
        // that matches the corresponding item in the itemsForComparison array
        if (itemForComparison && currentDiv.matches(`#${containerId}[data-sku="${itemForComparison.sku}"]`)) {
            return;
        }

        // Remove the current div
        currentDiv.remove();

        // If there is no item for comparison, create an empty card
        if (!itemForComparison) {
            const newEmptyDiv = document.createElement('div');
            newEmptyDiv.id = containerId;
            newEmptyDiv.dataset.sku = '';
            newEmptyDiv.innerHTML = `
                <div class="item">
                    <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12.3553 20.5915H11.6481V12.6719H3.72855V11.9648H11.6481V4.04521H12.3553V11.9648H20.2749V12.6719H12.3553V20.5915Z"
                            fill="#1C1B1F"
                        />
                    </svg>
                </div>
            `;

            comparisonContainer.appendChild(newEmptyDiv);
            return;
        }

        // Create a new div for the selected product
        const newProductDiv = document.createElement('div');
        newProductDiv.id = containerId;
        newProductDiv.dataset.sku = itemForComparison.sku;
        const inputId = `comparison-product${index + 1}`;
        newProductDiv.innerHTML = `
            <div class="item selected">
                <div class="field" style="width:100%;margin:0;position:absolute;top:7px;left:24px;z-index:1;">
                    <ul class="check-radio">
                        <li class="checkbox-wrapper" style="height:50px;margin:0;">
                            <input
                                type="checkbox"
                                name="products"
                                id="${inputId}"
                                value="${itemForComparison.sku}"
                                checked
                                data-sku="${itemForComparison.sku}"
                            />
                            <label for="${inputId}" style="padding:17px 17px 17px 0;"><span>Compare</span></label>
                        </li>
                    </ul>
                </div>

                <figure>
                    <img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" 
                        srcset="
                            ${itemForComparison.image1x} 1x,
                            ${itemForComparison.image2x} 2x
                        "
                        alt="${itemForComparison.title}"
                    >
                </figure>
            </div>
        `;

        comparisonContainer.appendChild(newProductDiv);
    });

    // Update the "compare products" url
    if (comparePageLink) {
        const queryString = itemsForComparison.map((item, index) => `product${index + 1}=${item.sku}`).join('&');
        comparePageLink.href = `/compare?${queryString}`;
    }
};

document.addEventListener('click', function(e) {
    if (!e.target.matches('input[name="products"]')) {
        return;
    }

    const checkbox = e.target;
    const { checked } = checkbox;

    if (itemsForComparison.length === 3 && checked) {
        console.log('Maximum of 3 images for comparison reached.');
        e.preventDefault();
        return;
    }

    const { title, sku, image1x, image2x } = checkbox.dataset;

    if (!checked) {
        const index = itemsForComparison.findIndex(item => item.sku === sku);
        if (index !== -1) {
            itemsForComparison.splice(index, 1);
        }

        // If the event was triggered by unchecking a checkbox in the comparison container,
        // uncheck the corresponding checkbox in the search result cards.
        const inputElement = document.querySelector(`input[name="products"][value="${sku}"]`);
        if (inputElement) {
            inputElement.checked = false;
        }
    } else {
        itemsForComparison.push({
            title,
            sku,
            image1x,
            image2x,
        });
    }

    renderComparisonImages();
});

if (comparePageLink) {
    comparePageLink.addEventListener('click', function(e) {
        if (itemsForComparison.length < 2) {
            e.preventDefault();
            alert('You must select at least 2 products to compare.');
        }
    });
}

if (clearSelectionLink) {
    clearSelectionLink.addEventListener('click', function(e) {
        e.preventDefault();

        // Uncheck the checkboxes in the search result cards
        itemsForComparison.forEach(item => {
            const inputElement = document.querySelector(`input[name="products"][value="${item.sku}"]`);
            if (inputElement) {
                inputElement.checked = false;
            }
        });

        itemsForComparison.length = 0;
        renderComparisonImages();
    });
}